export const TalitsiData = [
    {
        title: "дом №1",
        year: '1949',
        floor: "2",
        apartment: "8",
        quantityLC: "9",
        livingArea: "369,4",
        notLivinigArea: "нет",
        commonProperty: "51,4",
        type: "многоэтажный жилой дом",
        level: "отопление, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'talitsi/talitsi_1_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }
]